'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function HomePage() {
  const router = useRouter()

  useEffect(() => {
    // Check if user is authenticated
    const token = localStorage.getItem('auth_token')
    if (token) {
      // Role-aware landing: reps go to their personal dashboard.
      let role = ''
      try {
        role = JSON.parse(localStorage.getItem('user_info') || '{}').role || ''
      } catch {
        /* fall through to the global dashboard */
      }
      const isManagement = role === 'owner' || role === 'manager'
      router.push(isManagement || !role ? '/dashboard' : '/dashboard/rep')
    } else {
      router.push('/login')
    }
  }, [router])

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="h-8 w-8 mx-auto mb-4 rounded-lg bg-primary flex items-center justify-center text-primary-foreground">
          EC
        </div>
        <p className="text-muted-foreground">Loading...</p>
      </div>
    </div>
  )
}
